// extracted by mini-css-extract-plugin
module.exports = {"sharegraphContainer":"Datablock_Sharegraph_sharegraphContainer__VSDQA"};